import { useState } from 'react';
import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import useCustomer from 'src/hooks/useCustomer';
import BasePrimaryNavItem from './BasePrimaryNavItem';

declare interface Props {
  isPopover?: boolean;
}

const ReportItem: FC<React.PropsWithChildren<Props>> = (props) => {
  const [open, setOpen] = useState<boolean>(false);
  const { customer } = useCustomer();
  const menu = {
    section: 'Reports',
    items: [
      {
        title: 'Run Report',
        path: `../${customer.number.toString()}/reports`,
      },
    ],
  };

  const handleClose = () => {
    setOpen(!open);
  };

  const content = (
    <>
      <p className="global-nav__section-title">{menu.section}</p>
      <div className="global-nav__item">
        {menu.items.map((item, index) => {
          return (
            <div className="global-nav__item-link" key={index}>
              <RouterLink to={item.path} key={index} onClick={handleClose}>
                {item.title}
              </RouterLink>
            </div>
          );
        })}
      </div>
    </>
  );

  return (
    <BasePrimaryNavItem anchorEl={menu.section} isPopover={props.isPopover} isOpen={open}>
      {content}
    </BasePrimaryNavItem>
  );
};

export default ReportItem;
